module.exports = __webpack_public_path__ + "img/svampe_pasta.44fc6246.jpg";